import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Clock3 } from "lucide-react";
import { useLang } from "../i18n";

export default function PaymentPending() {
    const [params] = useSearchParams();
    const ref = params.get("ref") || "";
    const { t } = useLang();
    return (
        <div data-testid="payment-pending-page" className="pt-36 pb-24 min-h-screen">
            <div className="max-w-xl mx-auto px-4 sm:px-6 text-center">
                <Clock3 size={52} className="mx-auto text-lakou-gold" />
                <h1 className="mt-6 font-display font-black text-3xl text-lakou-cream tracking-tight" data-testid="payment-pending-title">
                    {t("pending_title")}
                </h1>
                <p className="mt-3 text-lakou-grey leading-relaxed">{t("pending_sub")}</p>
                {ref && (
                    <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-lakou-gold/30 px-5 py-2 font-mono2 text-sm tracking-[0.2em] text-lakou-gold" data-testid="pending-reference">
                        {ref}
                    </div>
                )}
                <div className="mt-10">
                    <Link to="/" data-testid="pending-back-home"
                        className="rounded-full border border-lakou-gold/40 text-lakou-cream hover:text-lakou-gold font-display font-bold text-xs uppercase tracking-[0.15em] px-8 py-4 transition-colors">
                        {t("pay_back")}
                    </Link>
                </div>
            </div>
        </div>
    );
}
